import React from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import SvgReplay from 'assets/images/svgs/ico_replay.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { PLAYER_REPLAY_BUTTON } from 'config/testID';

import { isWeb } from 'utils/responsiveness';

import styles from 'components/CatchupIcon/styles';

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: { ACCESSIBILITY_ICON_CATCHUP },
    },
} = LANGUAGE_KEYS;

export default function ReplayIcon({
    size = 24,
    ableToStartOver,
    style,
    tabIndex,
}: {
    ableToStartOver: boolean;
    size?: number;
    style?: {};
    tabIndex?: 0 | -1;
}) {
    const { t } = useTranslation();

    if (ableToStartOver) {
        return (
            <View
                style={[styles.iconContainer, style]}
                testID={PLAYER_REPLAY_BUTTON}
                accessibilityLabel={t(ACCESSIBILITY_ICON_CATCHUP)}
                accessibilityRole="image"
                accessible
                {...(isWeb && { tabIndex })}
            >
                <SvgReplay width={size} height={size} />
            </View>
        );
    }

    return null;
}
